export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function toBase64Only(dataUrl) {
  if (!dataUrl || typeof dataUrl !== "string") return null;
  const idx = dataUrl.indexOf(",");
  return idx >= 0 ? dataUrl.slice(idx + 1) : dataUrl;
}

export async function buildAttachmentFields(file) {
  if (!file) return {};
  const dataUrl = await fileToBase64(file);
  return {
    attachmentBase64: toBase64Only(dataUrl),
    attachmentFileName: file.name ?? null,
    attachmentContentType: file.type ?? null,
  };
}
 